module.exports = __webpack_public_path__ + "static/media/gameVideo2.7486a236.png";